import {HttpClient} from '@angular/common/http';
import {EventEmitter, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {environment} from 'src/environments/environment';

import {getPrefixPonto, isNullOrEmpty, isNullOrUndefined} from '../../../../../../utils/util';
import {MarkerAGM} from '../models/marker-agm';
import {MarkerAGMParams} from '../models/marker-agm-params.model';
import {PedidosPreCargaModel} from '../models/pedidos-pre-carga.model';
import {TipoAgrupamento} from '../models/tipo-agrupamento.enum';
import {MapaRoteirizacaoComponent} from '../components/mapa-roteirizacao/mapa-roteirizacao.component';
import {EntregaSequenciaModel} from '../../../models';
import {ClienteEntregaModel} from '../../../models/cliente-entrega.model';
import {CurrencyPipe} from '@angular/common';
import {PolignoModel} from '../../../models/poligono.model';
import {PracaService} from '../../../services/praca.service';
import {ParametroPortalService} from '../../../services/parametro-portal.service';
import {ParamEspecificoLocalStorageService} from './param-especifico-local-storage.service';
import {EntregaPedidoConfig} from '../component/filtro-dialog/config/entrega-pedido.config';
import {CapacidadeFormaterPipe} from '../../../../../core/shared-components/pipe/capacidade.pipe';
import {exibirDataNoFuso} from '../../../../../../utils/date';
import {cloneDeep, isEqual} from 'lodash';
import { PreCargaRotaModel } from '../../../models/pre-carga-rota.model';
import { RouteModel } from '../../../models/planing';
import { PreCargaModel } from '../models/pre-carga.model';
import {ParametroModel} from '../../configuracoes/parametros/parametro.model';
import {Utils} from 'ngx-bootstrap/utils';
import {EntregaPreCargaModel} from '../models/entregas-pre-carga.model';
import {filtrarCoordenadas} from '../../../../../../utils/coordenadas-utils';
import { RomaneioRoteirizacaoModel } from '../../../models/romaneio/romaneio-roteirizacao-model';
import {TipoPontoDeChegadaEnum} from '../../../enums/tipo-ponto-de-chegada.enum';

@Injectable({providedIn: 'root'})
export class MapUtilsService {

  currencyPipe: CurrencyPipe = new CurrencyPipe('pt-BR');
  capacidadeFormaterPipe = new CapacidadeFormaterPipe();
  origemDetalhesEntrega = false;

  constructor(
    private httpClient: HttpClient,
    private pracaService: PracaService,
    private paramEspecificoLocalStorageService: ParamEspecificoLocalStorageService,
    private ngZone: NgZone,
  ) {
  }

  get drawingManager(): google.maps.drawing.DrawingManager {
    return this._drawingManager;
  }

  URL_ICON = `${environment.BASE_URL}/marcador/pin`;

  ANIMATION_BOUNCE = 'BOUNCE';

  _drawingManager: any;

  public markers: MarkerAGM[] = [];
  private markersComMesmaLocalizacao: MarkerAGM[] = []
  copiaMarkersAntesDaTransferencia: MarkerAGM[] = [];
  private quantidadeSelecaoBloqueada = 0;

  public polygonsAreasAtendimento: PolignoModel[] = [];

  private markersFiltrados = new BehaviorSubject<MarkerAGM[]>([]);

  private markersNasAreasDeAtendimentoSelecionadas = new BehaviorSubject<MarkerAGM[]>([]);

  fornecedoresFiltrados = new BehaviorSubject<string[]>([]);
  private pedidosOcultosPorFiltroFornecedor = new Map<MarkerAGM, PedidosPreCargaModel[]>();

  polygonoEventEmitter = new EventEmitter();
  retanguloCirculoEventEmitter = new EventEmitter();
  circleChangedEventEmitter = new EventEmitter();
  polygonChangedEventEmitter = new EventEmitter();
  polygonAreasAtendimentoChangedEventEmitter = new EventEmitter();

  alterouPedidosEntregasEvent = new EventEmitter();

  urlIconDeparture = './assets/img/icons/cd.png';
  urlIconArrival = './assets/demo/default/media/img/logo/finish_flag.png';
  urlIconPontoDePassagem = './assets/img/marker/ponto-de-passagem.svg';
  spiderIcon = './assets/img/marker/spider.svg';
  iconesArmazenados = new Map<string, string>();
  /** Ícones gerados a partir dos SVGs locais (ver getIconLocalMarker). */
  private iconesLocaisGerados = new Map<string, Promise<string>>();
  private svgsMarkerLocal = new Map<string, Promise<string>>();

  private preCargaRotas = new BehaviorSubject<PreCargaRotaModel[]>([]);

  getCorMarker = (key: string) => ({
    PADRAO: '#FF0000',
    ZONARISCO: '#ff9100',
    OBSERVACAO: '#4169E1',
    JANELAENTREGA: '#00D556',
    TRANSFERENCIA: '#008B8B',
    CLIENTEBLOQUEADO: '#f5e50e',
    OBS_PRECARGA: '#4169E1',
    AGENDAMENTO: '#ac59ff',
    AVULSO: '#fc03c6'
  }[key.toUpperCase()] || '#FF0000')

  criarMarkerAGM(markerAGMParams: MarkerAGMParams): MarkerAGM {
    const agm = new MarkerAGM();
    agm.latitude = markerAGMParams.lat;
    agm.longitude = markerAGMParams.long;
    agm.draggable = markerAGMParams.arrastavel;
    agm.icon = markerAGMParams.isPontoPassagem ? this.urlIconPontoDePassagem : markerAGMParams.icone;
    agm.title = markerAGMParams.titulo;
    agm.zIndex = 0;
    agm.animation = null;
    agm.cliente = {
      id: markerAGMParams.idCliente,
      idEndEntrega: markerAGMParams.idEnderecoEntrega,
      nome: markerAGMParams.nomeCliente,
      fantasia: markerAGMParams.nomeFantasia,
      razaoSocial: markerAGMParams.razaoSocial,
      idCidade: markerAGMParams.idCidade ? markerAGMParams.idCidade : null,
      idRca: markerAGMParams.idRca ? markerAGMParams.idRca : null,
      idRota: markerAGMParams.idRota ? markerAGMParams.idRota : null,
      descricaoRota: markerAGMParams.descricaoRota ? markerAGMParams.descricaoRota : null,
      idPraca: markerAGMParams.idPraca ? markerAGMParams.idPraca : null,
      praca: markerAGMParams.praca ? markerAGMParams.praca : null,
      idRegiao: markerAGMParams.idRegiao ? markerAGMParams.idRegiao : null,
      bairro: markerAGMParams.bairro ? markerAGMParams.bairro : null,
      cep: markerAGMParams.cep ? markerAGMParams.cep : null,
      cidade: markerAGMParams.cidade ? markerAGMParams.cidade : null,
      estado: markerAGMParams.uf ? markerAGMParams.uf : null,
      endereco: markerAGMParams.endereco ? markerAGMParams.endereco : null,
      numero: markerAGMParams.numero ? markerAGMParams.numero : null,
      taxaDificuldadeEntrega: markerAGMParams.taxaDificuldadeEntrega ? markerAGMParams.taxaDificuldadeEntrega : null,
      obsRota: markerAGMParams.obsRota,
      pontoReferencia: markerAGMParams.pontoReferencia
    };
    agm.labelIcon = markerAGMParams.labelIcon;
    agm.pedidoBloqueadoPendente = markerAGMParams.pedidoBloqueadoPendente;
    agm.clientePossuiJanelaEntrega = markerAGMParams.clientePossuiJanelaEntrega;
    agm.janelaEntregaHabilitada = markerAGMParams.clientePossuiJanelaEntrega;
    agm.isIdentificacaoPersonalizada = markerAGMParams.isIdentificacaoPersonalizada;
    agm.possuiObservacao = markerAGMParams.possuiObservacao;
    agm.possuiCorConfigFiltro = markerAGMParams.possuiCorConfigFiltro;
    agm.corConfigSalva = markerAGMParams.corConfigSalva;
    agm.pedidos = [...markerAGMParams.pedidos || []];
    agm.zonaRisco = markerAGMParams.zonaRisco;
    agm.isPontoPassagem = markerAGMParams.isPontoPassagem;
    agm.isPontoParada = markerAGMParams.isPontoParada;
    agm.reentrega = markerAGMParams.reentrega;
    agm.idPraca = markerAGMParams.idPraca;
    agm.praca = markerAGMParams.praca;
    agm.possuiAgendamento = markerAGMParams.possuiAgendamento;
    agm.agendamento = markerAGMParams.agendamento;
    agm.valor = markerAGMParams.valor;
    agm.possuiPedidoAvulso = this.verificarPossuiPedidoAvulso(markerAGMParams.pedidos);
    agm.possuiPedidosEmAtraso = markerAGMParams.possuiPedidosEmAtraso;
    agm.idRota = markerAGMParams.idRota;
    agm.descricaoRota = markerAGMParams.descricaoRota;
    return agm;
  }

  criarMarkerAGMPontoDePartidaChegada(lat: any, long: any, titulo: string,  tipoPontoChegada: TipoPontoDeChegadaEnum) {
    return this.criarMarkerAGM({
      lat,
      long,
      titulo,
      arrastavel: false,
      icone: tipoPontoChegada === TipoPontoDeChegadaEnum.MO || tipoPontoChegada === TipoPontoDeChegadaEnum.UE
        ? this.urlIconArrival : this.urlIconDeparture ,
      idCliente: '',
      idEnderecoEntrega: '',
      nomeCliente: '',
      nomeFantasia: '',
      razaoSocial: '',
      labelIcon: ''
    });
  }

  criarMarkerAGMPontoDeChegada(lat: any, long: any, titulo: string) {
    return this.criarMarkerAGM({
      lat,
      long,
      titulo,
      arrastavel: false,
      icone: this.urlIconArrival,
      idCliente: '',
      idEnderecoEntrega: '',
      nomeCliente: '',
      nomeFantasia: '',
      razaoSocial: '',
      labelIcon: ''
    });
  }

  criarMarkerAGMPontoDePassagem(lat: any, long: any, titulo: string, idCliente?: string) {
    return this.criarMarkerAGM({
      lat,
      long,
      titulo,
      arrastavel: false,
      icone: this.urlIconPontoDePassagem,
      idCliente,
      idEnderecoEntrega: '',
      nomeCliente: '',
      nomeFantasia: '',
      razaoSocial: '',
      labelIcon: '',
      isPontoPassagem: true
    });
  }

  async criarMarkerAGMPontoDeParada(dado: any, indexMarker, idCliente) {
    return this.criarMarkerAGM({
      lat: dado.endereco.latitude,
      long: dado.endereco.longitude,
      titulo: dado.descricao,
      arrastavel: false,
      icone: await this.validarFlags('', false, indexMarker.toString(), false, true),
      idCliente,
      idEnderecoEntrega: '0',
      nomeCliente: '',
      nomeFantasia: '',
      razaoSocial: '',
      labelIcon: '',
      isPontoParada: true,
    });
  }

  public async criarMarkerEntrega(entrega, considerarTodasAsObservacoes = true): Promise<MarkerAGM> {
    let cor = this.getCorLegenda(entrega, considerarTodasAsObservacoes);

    if (entrega.cor) {
      cor = entrega.cor;
    }

    const {id, identificacaoPersonalizada, clientePossuiJanelaEntrega, qtdPedido} = entrega;

    const cep =  !isNullOrEmpty(entrega.cep) ? entrega.cep : '000';
    const label = await this.obterLabelPin(entrega, cep, qtdPedido);
    const marker: MarkerAGM = this.criarMarkerAGM({
      ...entrega,
      idCliente: id,
      arrastavel: false,
      labelIcon: (await this.obterParametroValidarAtrasoEntrega() && entrega.possuiPedidosEmAtraso ? qtdPedido + '\nA' : qtdPedido),
      lat: entrega.latitude,
      long: entrega.longitude,
      nomeCliente: entrega.nome,
      nomeFantasia: entrega.fantasia,
      janelaEntregaHabilitada: clientePossuiJanelaEntrega,
      isIdentificacaoPersonalizada: identificacaoPersonalizada,
      titulo: this.getTituloMarker(entrega),
      icone: await this.validarFlags(cor, identificacaoPersonalizada, label, entrega.isPontoPassagem, null, entrega.reentrega),
      possuiObservacao: entrega.pedidos && entrega.pedidos.some(element =>
        (considerarTodasAsObservacoes && (element.obs || element.obs1 || element.obs2))
        || element.obsEntrega || element.obsEntrega1 || element.obsEntrega2 || element.obsEntrega3),
      reentrega: entrega.reentrega,
      idPraca: entrega.idPraca,
      praca: entrega.praca,
      possuiAgendamento: entrega.possuiAgendamento,
      possuiPedidoAvulso: this.verificarPossuiPedidoAvulso(entrega.pedidos),
      possuiPedidosEmAtraso: entrega.possuiPedidosEmAtraso,
      idRota: entrega.idRota,
      descricaoRota: entrega.descricaoRota
    });
    marker.cor = cor;
    marker.corRota = entrega.corRota;
    marker.corRamoAtividade = entrega.corRamoAtividade;
    marker.corCliente = entrega.corCliente;

    return marker;
  }

  async obterLabelPin(entrega: any, cep: string, qtdPedido: number): Promise<string | number> {
    let label = '';
    if(await this.obterParametroExibirCepPin()) {
      label = cep.slice(0, 3);
    } else {
      label = qtdPedido.toString();
    }

    if(await this.obterParametroValidarAtrasoEntrega() && entrega.possuiPedidosEmAtraso) {
      label += '\nA';
    }

    return label;
  }

  getTituloMarker(entrega) {

    const {id} = entrega;
    const praca = entrega.idPraca || entrega.praca ? entrega.idPraca + ' - ' + entrega.praca : 'não possui';
    const rota = entrega.idRota || entrega.descricaoRota ? entrega.idRota + ' - ' + entrega.descricaoRota : 'não possui';
    const valorTotalPedidos = entrega.pedidos.reduce((acumulador, pedido) => acumulador + pedido.valorTotal, 0);
    const valorDaEntrega = this.currencyPipe.transform(valorTotalPedidos, 'BRL');
    const obsRota = entrega.obsRota ? entrega.obsRota : 'não possui.';

    let infoPedidos = '';
    entrega.pedidos.forEach(p => {
      infoPedidos += `\nPedido: ${p.numeroPedido}. NF: ${p.numeroNota}. Data: ${exibirDataNoFuso(p.data)}.`
        + ` Peso: ${this.capacidadeFormaterPipe.transform(p.pesoTotal, 'Kg')}.`
        + ` Volume: ${this.capacidadeFormaterPipe.transform(p.volumeTotal, 'm³')}. Valor: ${this.currencyPipe.transform(p.valorTotal, 'BRL')}.`
        + ` ${p.idRca != null && p.nomeRca != null ? 'Rca: ' + p.idRca + ' - ' + p.nomeRca + '.' : ''}`
        + ` ${p.obsEntrega ? 'Obs. Entrega: ' + p.obsEntrega + '. ' : ''}`
        + `${p.obsEntrega1 ? 'Obs. Entrega 1: ' + p.obsEntrega1 + '. ' : ''}`
        + `${p.obsEntrega2 ? 'Obs. Entrega 2: ' + p.obsEntrega2 + '. ' : ''}`
        + `${p.obsEntrega3 ? 'Obs. Entrega 3: ' + p.obsEntrega3 + '. ' : ''}`;
    });


    return `Cliente: ${id ? id : ''} - ${entrega.razaoSocial}. \nFantasia: ${entrega.fantasia}.\nPraça: ${praca}.` +
      `\nRota: ${rota}. \nObs. Rota: ${obsRota} \nCidade: ${entrega.cidade} \nEndereço: ${entrega.endereco}` +
      `\nNúmero: ${entrega.numero} \nCep: ${entrega.cep} \nValor da entrega: ${valorDaEntrega}. ${infoPedidos}`;
  }

  criarLatLng(latitude, longitude): google.maps.LatLng {
    return new google.maps.LatLng(latitude, longitude);
  }

  removerMap(obj) {
    if (obj && obj.map) {
      obj.setMap(null);
    }
  }

  adicionarMarker(marker) {
    if (!this.existeMarkerParaClienteEnderecoEntrega(marker)) {
      this.markers.push(marker);
    }
  }

  removerMarker(marker: MarkerAGM): void {
    const index = this.markers.findIndex(m => this.markersClienteEnderecoEntregaIguais(m, marker));

    this.markers.splice(index, 1);

    this.atualizaMarkers();
  }

  existeMarkerParaClienteEnderecoEntrega(marker: MarkerAGM) {
    return this.markers.find(m => this.markersClienteEnderecoEntregaIguais(m, marker));
  }

  obterMarkerPorMarkerPreCarga(marker: MarkerAGM) {
    return this.markers.find(m =>
      m.cliente.id === marker.cliente.id && (m.cliente.idEndEntrega || '0') === marker.cliente.idEndEntrega);
  }

  limparMarkers() {
    this.markers = [];
    this.pedidosOcultosPorFiltroFornecedor.clear();
    this.fornecedoresFiltrados.next([]);
  }

  atualizaMarkers() {
    this.alterouPedidosEntregasEvent.emit();
  }

  getCorLegenda(marker, considerarTodasAsObservacoes = true) {
    let cor;
    if (marker.possuiCorConfigFiltro) {
      cor = marker.cor;
      if (marker.cor !== marker.corConfigSalva) {
        cor = marker.corConfigSalva;
      }
    } else {
      cor = this.getCorMarker('PADRAO');
    }

    if (marker.pedidoBloqueadoPendente) {
      cor = this.getCorMarker('CLIENTEBLOQUEADO');
    } else if (marker.clientePossuiJanelaEntrega || marker.janelaEntrega) {
      cor = this.getCorMarker('JANELAENTREGA');
    } else if (marker.possuiObservacao) {
      cor = this.getCorMarker('OBS_PRECARGA');
    } else if (marker.pedidos != null && (typeof marker.pedidos !== 'string' || marker.possuiObservacao)) {
      marker.pedidos.some(element => (considerarTodasAsObservacoes && (element.obs || element.obs1 || element.obs2))
        || element.obsEntrega || element.obsEntrega1 || element.obsEntrega2 || element.obsEntrega3)
        ? cor = this.getCorMarker('OBSERVACAO') : cor = this.getCorMarker('PADRAO');
    }

    if (marker.zonaRisco) {
      cor = this.getCorMarker('ZONARISCO');
    }

    if (cor === this.getCorMarker('PADRAO') && (marker.possuiAgendamento || marker.agendamento)) {
      cor = this.getCorMarker('AGENDAMENTO');
    }

    if (marker.corRota != null) {
      cor = marker.corRota;
    }

    if (marker.corRamoAtividade != null) {
      cor = marker.corRamoAtividade;
    }

    if (marker.corCliente != null) {
      cor = marker.corCliente;
    }

    if (!isNullOrUndefined(marker.pedidos) || !isNullOrUndefined(marker.listaPedidos)) {
      const possuiPedidoAvulso = marker.pedidos && typeof marker.pedidos !== 'string' ? marker.pedidos.some(ped => ped.tipo === 'CA' || ped.tipo === 'EA') :
        marker.possuiPedidoAvulso;
      if (possuiPedidoAvulso) {
        cor = this.getCorMarker('AVULSO');
      }
    }

    return cor;
  }

  getUrlIcon(cor: string, label?: string | number, transferencia = false): string {
    label = label != null ? label.toString() : ' ';
    const color = cor || '#FF0000';
    const size =  label.length < 3 ? 26 : 30;
    const height = 37;
    const chave = cor + label + (transferencia ? '|transf-setas' : '');

    const valorSalvoMemoria = this.iconesArmazenados.get(chave);
    if (valorSalvoMemoria != null) {
      return valorSalvoMemoria;
    }

    const linhas = label.split('\n');
    const temQuebraDeLinha = linhas.length > 1;

    const tspans = linhas
      .map((linha, i) => {
        const offset = i === 0 ? 0 : 16;
        const fontSize = i === 0 ? 16 : 12;
        return `<tspan x="20" dy="${offset}" font-size="${fontSize}">${linha}</tspan>`;
      })
      .join('');

    const y = temQuebraDeLinha ? 22 : 27;
    const seloTransferencia = transferencia ? `
      <g transform="translate(29,11)">
        <circle cx="0" cy="0" r="9" fill="#ffffff" stroke="#1f1f1f" stroke-width="0.75"/>
        <g fill="none" stroke="#1a1a1a" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
          <path d="M0 5.4 L-4.8 -1.8"/>
          <path d="M-1.4 0 L-4.8 -1.8 L-4.4 2"/>
          <path d="M0 5.4 L4.8 -1.8"/>
          <path d="M1.4 0 L4.8 -1.8 L4.4 2"/>
        </g>
      </g>` : '';

    const encoded = encodeURIComponent(`
    <svg width="${size}" height="${height}" viewBox="0 0 40 60" xmlns="http://www.w3.org/2000/svg">
      <path d="M20,0 C31,0 40,9 40,20 C40,35 20,60 20,60 C20,60 0,35 0,20 C0,9 9,0 20,0 Z"
            fill="${color}" stroke="black" stroke-width="0.5"/>
      <text x="20" y="${y}" text-anchor="middle" fill="white" font-family="Arial" font-weight="bold">
        ${tspans}
      </text>
      ${seloTransferencia}
    </svg>
  `);

    const svg = `data:image/svg+xml;charset=UTF-8,${encoded}`;
    this.iconesArmazenados.set(chave, svg);
    return svg;
  }

  /**
   * Gera o ícone (PNG) a partir de um SVG local.
   * Com chaveCache (que deve identificar tudo o que o callback altera no SVG, ex.: cor e label) o ícone gerado
   * é reaproveitado, em vez de baixar o SVG e desenhar em um canvas para cada marker.
   */
  getIconLocalMarker(name: string, callback?: (inlineSvg: SVGSVGElement) => void, {
    width = 40,
    height = 40,
    chaveCache = null
  }: { width?: number, height?: number, chaveCache?: string } = {}): Promise<string> {
    if (chaveCache == null) {
      return this.gerarIconLocalMarker(name, callback, width, height);
    }

    const chave = `${name}|${width}x${height}|${chaveCache}`;
    let icone = this.iconesLocaisGerados.get(chave);
    if (!icone) {
      icone = this.gerarIconLocalMarker(name, callback, width, height);
      this.iconesLocaisGerados.set(chave, icone);
    }
    return icone;
  }

  private obterSvgMarkerLocal(name: string): Promise<string> {
    let svg = this.svgsMarkerLocal.get(name);
    if (!svg) {
      svg = this.httpClient.get(`assets/img/marker/${name}.svg`, {responseType: 'text'}).toPromise();
      this.svgsMarkerLocal.set(name, svg);
      // Em caso de erro, permite tentar novamente na próxima chamada
      svg.catch(() => this.svgsMarkerLocal.delete(name));
    }
    return svg;
  }

  private gerarIconLocalMarker(name: string, callback: (inlineSvg: SVGSVGElement) => void, width: number, height: number): Promise<string> {
    return new Promise<string>(async (resolve) => {
      const svgIcon = await this.obterSvgMarkerLocal(name);
      const {canvas, span, DOMURL, imagem} = this.fabricaObj();
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      span.innerHTML = svgIcon;
      const inlineSvg: SVGSVGElement = span.getElementsByTagName('svg')[0];
      callback(inlineSvg);
      const svgString = new XMLSerializer().serializeToString(inlineSvg);
      const svg = new Blob([svgString], {type: 'image/svg+xml;charset=utf-8'});
      const urlSvg = DOMURL.createObjectURL(svg);
      imagem.onload = () => {
        ctx.drawImage(imagem, 0, 0);
        const png = canvas.toDataURL('image/png');
        // Libera a URL do blob do SVG (antes era passada a URL do PNG, e o blob nunca era liberado)
        DOMURL.revokeObjectURL(urlSvg);
        resolve(png);
      };
      imagem.src = urlSvg;
    });
  }

  fabricaObj = () => ({
    canvas: document.createElement('canvas'),
    span: document.createElement('span'),
    DOMURL: self.URL || webkitURL,
    imagem: new Image(),
  })


  validarFlags(chaveCor: string, flag: boolean, label, pontoPassagem: boolean, pontoParada?: boolean, reentrega?: boolean): Promise<string> | string {
    if (pontoPassagem) {
      return this.getIconLocalMarker('ponto-de-passagem', () => null, {width: 24, height: 24, chaveCache: ''});
    }
    if (pontoParada) {
      return this.getIconLocalMarker('ponto-de-parada', (inlineSvg) => {
        inlineSvg.getElementById('text-star').textContent = `${label}`;
      }, {width: 24, height: 24, chaveCache: `${label}`});
    }
    if (flag) {
      return this.getIconLocalMarker('marker-identificacaoPer', (inlineSvg) => {
        inlineSvg.getElementById('text-star').textContent = `${label}`;
        inlineSvg.getElementById('content-star')
          .setAttribute('fill', chaveCor);
      }, {chaveCache: `${chaveCor}|${label}`});
    }
    if (reentrega) {
      return this.getIconLocalMarker('marker-reentrega', (inlineSvg) => {
        inlineSvg.getElementById('text-star').textContent = `${label}`;
      }, {chaveCache: `${label}`});
    }
    return this.getUrlIcon(chaveCor, label);

  }

  getCentroMapLocNavegador() {
    const retorno$ = new Subject();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(posicao => {
        retorno$.next({
          latitude: posicao.coords.latitude,
          longitude: posicao.coords.longitude
        });
      }, () => {
        retorno$.next({});
      });

      setTimeout(() => {
        retorno$.next({});
      }, 3000);

    } else {
      retorno$.next({});
    }
    return retorno$;
  }

  centralizarMapLocNavegador(mapa) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(posicao => {
        mapa.setCenter(this.criarLatLng(posicao.coords.latitude, posicao.coords.longitude));
      });
    }
  }

  centralizarMapa(mapa, localizacao: { latitude: any, longitude: any }) {
    mapa.setCenter(this.criarLatLng(localizacao.latitude, localizacao.longitude));
  }

  redefinirMarkerAtualizarOverlayPreCarga(marker: MarkerAGM, cor, isAnimated, overlay) {
    this.redefinirMarkerAGM(marker, cor, isAnimated, marker.idPreCarga);
    marker.overlayPreCarga = overlay;
  }

  async redefinirMarkerAGMEstadoInicial(marker: MarkerAGM, isPrimeiroMarker = false) {
    // Pin sem pré-carga não pode herdar o bloqueio de seleção de uma pré-carga descartada
    this.definirSelecaoBloqueada(marker, false);
    const parametro = await this.getParametroVisualizarSomenteObsEntrega();
    const {isIdentificacaoPersonalizada, pedidos, reentrega} = marker;

    let cor;

    if (isPrimeiroMarker) {
      cor = marker.corConfigSalva || this.getCorLegenda(marker, parametro === 'N');
    } else if (marker.pedidoTransf) {
      cor =  marker.corCliente || marker.corRamoAtividade || marker.corRota || this.getCorLegenda(marker, parametro === 'N');
    } else {
      cor = marker.cor || this.getCorLegenda(marker, parametro === 'N');
    }

    const cep =  !isNullOrEmpty(marker.cliente.cep) ? marker.cliente.cep : '000';
    const label = await this.obterLabelPin(marker, cep, pedidos.length);

    marker.icon = await this.validarFlags(cor, isIdentificacaoPersonalizada, label, marker.isPontoPassagem, null, reentrega);
    marker.animation = null;
    marker.cor = cor;
    marker.idPreCarga = null;
    marker.pedidos.forEach(pedido => {
      pedido.idPrecarga = null;
    });
    marker.pedidoTransf = false;
  }

  redefinirTodosMarcadiresAGMEstadoInicial() {
    this.markers.forEach(m => this.redefinirMarkerAGMEstadoInicial(m));
  }

  redefinirMarkersSelecionadosNoOverlay(listaMarkerSelecionados) {
    listaMarkerSelecionados.forEach(m => {
      const cor = this.getCorLegenda(m);
      this.redefinirMarkerAGM(m, cor, true, null);
    });

    this.atualizaMarkers();
  }

  async redefinirMarkerAGM(marker: MarkerAGM, cor, isAnimated, idPreCarga: string) {

    const cep = !isNullOrEmpty(marker.cliente.cep) ? marker.cliente.cep : '000';
    const label = await this.obterLabelPin(marker, cep, marker.pedidos.length);

    const corIcone = marker.isIdentificacaoPersonalizada ? marker.cor : cor;

    marker.icon = await this.validarFlags(
      corIcone,
      marker.isIdentificacaoPersonalizada,
      label,
      marker.isPontoPassagem,
      marker.isPontoParada,
      marker.reentrega
    );

    if (!marker.isIdentificacaoPersonalizada) {
      marker.cor = cor;
    }
    marker.idPreCarga = idPreCarga;

    if (isAnimated) {
      marker.animation = this.ANIMATION_BOUNCE;
    } else {
      marker.animation = null;
    }
  }

  async definirIconMarkerAGMRoteirizado(marker: MarkerAGM, preCarga) {
    marker.icon = this.getUrlIcon(preCarga.cor, await this.getLabelIconMarkerRoteirizado(marker, preCarga));
  }

  async getLabelIconMarkerRoteirizado(marker: MarkerAGM, preCarga): Promise<string | number> {
    let label: number | string = marker.pedidos.length;
    if (preCarga != null && preCarga.preCargaDTO != null && preCarga.preCargaDTO.solucao != null && preCarga.preCargaDTO.solucao.vehicleRoutes != null) {
      const activitiesDriving = preCarga.preCargaDTO.solucao.vehicleRoutes[0].routes[0].activities.filter(p => p.activity === 'DRIVING');
      const idEndEntrega = marker.cliente.idEndEntrega ? marker.cliente.idEndEntrega : '0';
      const index = activitiesDriving.findIndex(p => p.departureSite === marker.cliente.id + '_' + idEndEntrega);
      if (index !== -1) {
        label = index;
      }
    }

    if(await this.obterParametroValidarAtrasoEntrega() && marker.possuiPedidosEmAtraso) {
      label += '\nA';
    }

    return label;
  }

  redefinirOverlay(overlay, cor) {
    if (overlay && overlay.setOptions) {
      overlay.setOptions({
        strokeColor: cor,
        fillColor: cor,
        editable: false,
        draggable: false
      });
    }
  }

  obterLocalizacaoCentroBrasil() {
    const localizacao = {latitude: '-16.697406', longitude: '-49.257813'};
    return localizacao;
  }

  isLocalizacaoPreenchida(localizacao: { latitude: any; longitude: any; }): boolean {
    return localizacao
      && localizacao.latitude
      && localizacao.longitude
      && Number.parseFloat(localizacao.latitude) !== 0
      && Number.parseFloat(localizacao.longitude) !== 0;
  }

  /**
   * O DrawingManager é criado fora da zona do Angular: os listeners de ponteiro que ele registra no mapa
   * (e nas formas desenhadas) disparavam uma change detection da aplicação inteira a cada movimento do mouse
   * enquanto se desenhava. Os eventos usados pela aplicação voltam para a zona explicitamente:
   * - overlaycomplete e rightclick: com ngZone.run;
   * - alterações da forma (circleChanged/polygonChanged): emitidas fora da zona e o assinante entra na zona
   *   depois do debounce (ver RoteirizacaoComponent.ativarEscutasEventoDrawing).
   */
  configurarDrawing(mapa) {
    this.ngZone.runOutsideAngular(() => this.criarDrawingManager(mapa));
  }

  private criarDrawingManager(mapa) {
    this._drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.POLYGON,
          google.maps.drawing.OverlayType.CIRCLE,
          google.maps.drawing.OverlayType.RECTANGLE
        ]
      },
      circleOptions: {
        editable: true,
        draggable: false
      },
      polygonOptions: {
        editable: true,
        draggable: false
      },
      rectangleOptions: {
        editable: true,
        draggable: false
      },
      map: mapa
    });
    this.adicionarListenerDrawing(this.drawingManager);
    this.adicionarListenerCircle(this.drawingManager);
    this.adicionarListenerCircleCenter(this.drawingManager);
    this.adicionarListenerRectangle(this.drawingManager);
    this.adicionarListenerPolygon(this.drawingManager);
  }

  adicionarListenerDrawing(drawingManager) {
    google.maps.event.addListener(drawingManager, 'overlaycomplete', event => this.ngZone.run(() => {
      switch (event.type) {
        case google.maps.drawing.OverlayType.POLYGON: {
          // google.maps.event.addListener(this.overlay.getPath(), 'set_at', () => this.carregarDadosSelecaoPolygon(this.overlay));
          this.polygonoEventEmitter.emit(event);
          break;
        }
        default: {
          // google.maps.event.addListener(this.overlay, 'bounds_changed', () => this.carregarDadosSelecaoRectangle(this.overlay));
          this.retanguloCirculoEventEmitter.emit(event);
          break;
        }
      }
    }));
  }

  adicionarListenerCircle(drawingManager) {
    google.maps.event.addListener(drawingManager, 'circlecomplete', circle => {
      google.maps.event.addListener(circle, 'radius_changed', event => {
        this.circleChangedEventEmitter.emit(circle);
      });
    });
  }


  adicionarListenerRectangle(drawingManager) {
    google.maps.event.addListener(drawingManager, 'rectanglecomplete', rectangle => {
      google.maps.event.addListener(rectangle, 'bounds_changed', event => {
        this.circleChangedEventEmitter.emit(rectangle);
      });
    });
  }

  adicionarListenerCircleCenter(drawingManager) {
    google.maps.event.addListener(drawingManager, 'circlecomplete', circle => {
      google.maps.event.addListener(circle, 'center_changed', event => {
        this.circleChangedEventEmitter.emit(circle);
      });
    });
  }

  adicionarListenerPolygon(drawingManager) {
    google.maps.event.addListener(drawingManager, 'polygoncomplete', polygon => {
      google.maps.event.addListener(polygon.getPath(), 'insert_at', event => {
        this.polygonChangedEventEmitter.emit(polygon);
      });

      google.maps.event.addListener(polygon.getPath(), 'set_at', event => {
        this.polygonChangedEventEmitter.emit(polygon);
      });
    });
  }

  adicionarEventoBotaoDireitoOverlay(overlay, fn: () => void) {
    // As formas são criadas pelo DrawingManager fora da zona do Angular (ver configurarDrawing)
    google.maps.event.addListener(overlay, 'rightclick', () => this.ngZone.run(() => fn()));
  }

  redefinirMarkersPorOverlayAGM(overlay) {
    const markers = this.obterMarkersByOverlayOuFiltrados(overlay);

    markers.forEach(m => {
      if (!m.idPreCarga && !m.isIdentificacaoPersonalizada && !m.reentrega) {
        this.redefinirMarkerAGM(m, m.cor, false, null);
      } else {
        m.animation = null;
      }
    });
  }

  alterarAnimationMarkerParaBounce(marker) {
    marker.animation = this.ANIMATION_BOUNCE;
  }

  alterarAnimationMarkerParaParado(marker) {
    marker.animation = null;
  }

  definirSelecaoBloqueada(marker: MarkerAGM, bloqueada: boolean): void {
    if (!marker || !!marker.selecaoBloqueada === bloqueada) {
      return;
    }
    marker.selecaoBloqueada = bloqueada;
    this.quantidadeSelecaoBloqueada += bloqueada ? 1 : -1;
    if (bloqueada && marker.animation) {
      marker.animation = null;
    }
  }

  possuiSelecaoBloqueada(): boolean {
    return this.quantidadeSelecaoBloqueada > 0;
  }

  removerAnimacaoMarkers() {
    this.markers.forEach(marker => this.alterarAnimationMarkerParaParado(marker));
  }

  obterListaMarksAgmDentroOverlay(overlay): MarkerAGM[] {
    if (!overlay) {
      return [];
    }
    const novaListaMarkers = [];
    if (this.isOverlayIsPolygon(overlay)) {
      let marker: MarkerAGM;
      for (marker of this.markers) {
        if (this.podeSelecionarMarker(marker) && google.maps.geometry.poly.containsLocation(this.criarLatLng(marker.latitude, marker.longitude), overlay)) {
          novaListaMarkers.push(marker);
        }
      }
    } else if (this.isOverlayIsRectangle(overlay)) {
      let marker: MarkerAGM;
      for (marker of this.markers) {
        if (this.podeSelecionarMarker(marker) && overlay.getBounds().contains(this.criarLatLng(marker.latitude, marker.longitude))) {
          novaListaMarkers.push(marker);
        }
      }
    } else {
      if (typeof overlay.getRadius != 'function') { return []; }

      let marker: MarkerAGM;
      const raioCirculo = overlay.getRadius();
      const centroCirculo = overlay.getCenter();

      for (marker of this.markers) {
        if (this.podeSelecionarMarker(marker)) {
          const markerPosition = new google.maps.LatLng(marker.latitude, marker.longitude);
          const distancia = google.maps.geometry.spherical.computeDistanceBetween(markerPosition, centroCirculo);

          if (distancia <= raioCirculo) {
            novaListaMarkers.push(marker);
          }
        }
      }
    }

    return novaListaMarkers;
  }

  obterPedidosDoMarker(marker: MarkerAGM): PedidosPreCargaModel[] {
    return this.obterPedidosDosMarkersSelecionados([marker]);
  }

  obterPedidosDosMarkers(): PedidosPreCargaModel[] {
    return this.obterPedidosDosMarkersSelecionados(this.markers);
  }

  obterPedidosDosMarkersSelecionados(markers: MarkerAGM[]): PedidosPreCargaModel[] {
    const pedidos = [];
    if (markers) {
      markers.forEach(m => {
        const pedidosMap = m.pedidos.map(pedido => Object.assign(pedido, {
          idRota: m.cliente.idRota,
          fantasia: m.cliente.fantasia,
          razaoSocial: m.cliente.razaoSocial,
          latitude: m.latitude,
          longitude: m.longitude,
          janelaEntregaHabilitada: m.janelaEntregaHabilitada,
          cep: m.cliente.cep,
          bairro: m.cliente.bairro,
          cidade: m.cliente.cidade,
          endereco: m.cliente.endereco,
          numero: m.cliente.numero,
          nome: m.cliente.nome,
          peso: pedido.pesoTotal,
          volume: pedido.volumeTotal,
          valor: pedido.valorTotal,
          quantidadeItens: pedido.quantidadeItens,
          diasEntrega: pedido.diasEntrega,
          qtdDiasAtraso: pedido.qtdDiasAtraso

        }));
        pedidos.push(...pedidosMap);
      });
    }

    return pedidos;
  }

  obterPedidosDasEntregas(entregas: EntregaPreCargaModel[]): PedidosPreCargaModel[] {
    const pedidos = [];
    if (entregas) {
      entregas.forEach(e => {
        const pedidosMap = e.pedidos.map(pedido => Object.assign(pedido, {
          idRota: pedido.idRota,
          fantasia: e.fantasia,
          razaoSocial: e.nome,
          latitude: e.latitude,
          longitude: e.longitude,
          peso: pedido.pesoTotal,
          volume: pedido.volumeTotal,
          valor: pedido.valorTotal,
          quantidadeItens: pedido.quantidadeItens
        }));
        pedidos.push(...pedidosMap);
      });
    }
    return pedidos;
  }

  markerPossuiPedidosEmTransferencia(m: MarkerAGM) {
    const pedidosDoMarker: PedidosPreCargaModel[] = this.obterPedidosDosMarkersSelecionados([m]);
    const reduce = this.reducePrecargaDosPedidosDoMarker(pedidosDoMarker);
    return Object.keys(reduce).length > 1;
  }

  filtrarPedidoDoMarkerEmPrecarga(pedidosEmPrecarga: PedidosPreCargaModel[]):
    (value: PedidosPreCargaModel, index: number, array: PedidosPreCargaModel[]) => any {
    const numerosPedidosEmPrecarga = new Set(pedidosEmPrecarga.map(p => p.numeroPedido));
    return pedidoMarker => numerosPedidosEmPrecarga.has(pedidoMarker.numeroPedido);
  }

  /**
   * Cria uma lista de precargas as quais os pedidos de uma marker pertence
   * Com isso e possivel saber se os pedidos do marker estao em uma precarga só
   * ou divido em mais de uma
   */
  reducePrecargaDosPedidosDoMarker(pedidosMarker: PedidosPreCargaModel[]) {
    return pedidosMarker.reduce((map, p) => {
      if (!p.idPrecarga) {
        return map;
      }
      const key = p.idPrecarga;
      map[key] = map[key] || [];
      map[key].push(p);
      return map;
    }, {});
  }

  removerPedidoDoMarker(numeroPedido: number) {
    const marker: MarkerAGM = this.obterMarkerPeloNumeroDoPedido(numeroPedido);
    if (marker) {
      const indexPedidoNoMarker = marker.pedidos.findIndex(pedido => pedido.numeroPedido === numeroPedido);
      marker.pedidos.splice(indexPedidoNoMarker, 1);
    }
  }


  removerPedidoDoMarkerSemTiraDoMapa(listaPedidosSelecionados, animar = true) {
    const indiceMarkerPorPedido = this.criarIndiceMarkerPorNumeroPedido();
    for (const p of listaPedidosSelecionados) {
      const marker: MarkerAGM = indiceMarkerPorPedido.get(p.numeroPedido);
      if (marker) {
        const indexPedidoNoMarker = marker.pedidos.findIndex(pedido => pedido.numeroPedido === p.numeroPedido);
        if (indexPedidoNoMarker >= 0) {
          marker.pedidos.splice(indexPedidoNoMarker, 1);
          this.updateMarkers(marker, animar);
        }
      }
    }

    this.markers = this.markers.filter(m => m.pedidos.length > 0);
    this.atualizaMarkers();

  }

  async updateMarkers(marker: MarkerAGM, animar = true) {
    const param = await this.getParametroVisualizarSomenteObsEntrega();

    const cor = this.getCorLegenda(marker, param === 'N');
    marker.icon = this.getUrlIcon(cor, (await this.obterParametroValidarAtrasoEntrega() && marker.possuiPedidosEmAtraso ? marker.pedidos.length + '\nA' : marker.pedidos.length));
    marker.title = `Cliente: ${marker.cliente.id} - ${marker.cliente.fantasia || marker.cliente.nome} .\nPedidos: ${marker.pedidos.length}`;
    this.redefinirMarkerAGM(marker, cor, animar, null);

  }


  obterMarkerPeloNumeroDoPedido(numeroPedido: number): MarkerAGM {
    return this.markers.find(m => m.pedidos.find(pedido => pedido.numeroPedido === numeroPedido));
  }

  /**
   * Índice numeroPedido -> marker para uso em loops. Mantém o primeiro marker encontrado,
   * mesmo comportamento de obterMarkerPeloNumeroDoPedido.
   */
  criarIndiceMarkerPorNumeroPedido(): Map<number, MarkerAGM> {
    const indice = new Map<number, MarkerAGM>();
    this.markers.forEach(m => {
      m.pedidos.forEach(pedido => {
        if (!indice.has(pedido.numeroPedido)) {
          indice.set(pedido.numeroPedido, m);
        }
      });
    });
    return indice;
  }

  markersClienteEnderecoEntregaIguais(m: MarkerAGM, site: MarkerAGM): boolean {
    return m.cliente.id === site.cliente.id && m.cliente.idEndEntrega === site.cliente.idEndEntrega;
  }

  isOverlayIsRectangle(overlay: any) {
    return overlay instanceof google.maps.Rectangle;
  }

  isOverlayIsPolygon(overlay: any) {
    return overlay instanceof google.maps.Polygon;
  }

  isOverlayIsCircle(overlay: any) {
    return overlay instanceof google.maps.Circle;
  }

  agruparPeloTipoAgrupamento(tipoAgrupamento: TipoAgrupamento) {
    let mapAgrupamento = {};

    switch (tipoAgrupamento) {
      case TipoAgrupamento.CIDADE:
        mapAgrupamento = this.generateMapAgrupamentoCidade();
        break;

      case TipoAgrupamento.ROTA:
        mapAgrupamento = this.generateMapAgrupamentoRota();
        break;

      case TipoAgrupamento.RCA:
        mapAgrupamento = this.generateMapAgrupamentoRCA();
        break;

      case TipoAgrupamento.PRACA:
        mapAgrupamento = this.generateMapAgrupamentoPraca();
        break;

      case TipoAgrupamento.REGIAO:
        mapAgrupamento = this.generateMapAgrupamentoRegiao();
        break;

      case TipoAgrupamento.TRANSPORTADORA:
        mapAgrupamento = this.generateMapAgrupamentoTransportadora();
        break;
      case TipoAgrupamento.AREA_ATENDIMENTO:
        mapAgrupamento = this.generateMapAgrupamentoAreaAtendimento();
        break;
    }

    return mapAgrupamento;
  }

  private generateMapAgrupamentoCidade() {
    return this.markers.reduce((map, marker) => {
      if (marker.cliente.idCidade) {
        map[marker.cliente.idCidade] = map[marker.cliente.idCidade] || [];
        const agrupamento = {marker, pedidos: marker.pedidos};
        map[marker.cliente.idCidade].push(agrupamento);
      }
      return map;
    }, {});
  }

  private generateMapAgrupamentoRegiao() {
    return this.markers.reduce((map, marker) => {
      if (marker.cliente.idRegiao) {
        map[marker.cliente.idRegiao] = map[marker.cliente.idRegiao] || [];
        const agrupamento = {marker, pedidos: marker.pedidos};
        map[marker.cliente.idRegiao].push(agrupamento);
      }
      return map;

    }, {});
  }

  private generateMapAgrupamentoPraca() {
    return this.markers.reduce((map, marker) => {
      if (marker.cliente.idPraca) {
        map[marker.cliente.idPraca] = map[marker.cliente.idPraca] || [];
        const agrupamento = {marker, pedidos: marker.pedidos};
        map[marker.cliente.idPraca].push(agrupamento);
      }

      return map;
    }, {});
  }

  private generateMapAgrupamentoRota() {
    return this.markers.reduce((map, marker) => {
      if (marker.cliente.idRota) {
        map[marker.cliente.idRota] = map[marker.cliente.idRota] || [];
        const agrupamento = {marker, pedidos: marker.pedidos};
        map[marker.cliente.idRota].push(agrupamento);
      }

      return map;
    }, {});
  }

  private generateMapAgrupamentoRCA() {

    const listaFinal = this.markers.filter(this.filtroPedidosComRCA());

    return listaFinal.reduce((map, marker) => {
      const idRca = this.obterIdRcaDaEntrega(marker);
      map[idRca] = map[idRca] || [];
      const agrupamento = {marker, pedidos: marker.pedidos};
      map[idRca].push(agrupamento);
      return map;
    }, {});
  }

  public filtroPedidosComRCA(): (value: MarkerAGM, index: number, array: MarkerAGM[]) => boolean {
    return m => {
      const pedidos = m.pedidos.filter(p => !isNullOrUndefined(p.idRca));
      return !isNullOrEmpty(pedidos);
    };
  }

  public obterIdRcaDaEntrega(marker: MarkerAGM) {
    const [pedido] = marker.pedidos.filter(p => !isNullOrUndefined(p.idRca));
    return pedido ? pedido.idRca : null;
  }

  private generateMapAgrupamentoTransportadora() {

    const markers = this.markers.filter(this.markerPossuiPedidoComTransportadora());
    const pedidos = this.obterPedidosDosMarkersSelecionados(markers).filter(p => p.idTransportadora);

    const todosPedidosEmTela = this.obterPedidosDosMarkers();

    if (todosPedidosEmTela.length !== pedidos.length) {
      const msg = `Só é permitido agrupamento por
      transportadora quando todos os pedidos filtrados tiverem vínculo com a transportadora.`;
      throw new Error(msg);
    }

    const indiceMarkerPorPedido = this.criarIndiceMarkerPorNumeroPedido();

    return pedidos.reduce((map, pedido) => {
      map[pedido.idTransportadora] = map[pedido.idTransportadora] || [];
      const marker = indiceMarkerPorPedido.get(pedido.numeroPedido);
      if (!map[pedido.idTransportadora].map(m => m.marker).includes(marker)) {
        map[pedido.idTransportadora].push({marker, pedidos: [pedido]});
      } else {
        map[pedido.idTransportadora].find(this.obterMarkerAgrupadoTransportadora(marker)).pedidos.push(pedido);
      }
      return map;
    }, {});
  }

  public atribuirAreaAtendimentoMarkersPendentes() {
    const markersSemArea = this.markers.filter(m => !m.idAreaAtendimento);
    if (!markersSemArea.length || !this.polygonsAreasAtendimento || !this.polygonsAreasAtendimento.length) {
      return;
    }

    const areasVisiveis = this.polygonsAreasAtendimento.filter(a => a.visivel);
    for (const area of areasVisiveis) {
      if (!area.paths || !area.paths.length) {
        continue;
      }
      for (const path of area.paths) {
        const paths = path.map(p => (p instanceof google.maps.LatLng ? p : new google.maps.LatLng(p.lat, p.lng)));
        const poligono = new google.maps.Polygon({ paths });
        const bounds = new google.maps.LatLngBounds();
        poligono.getPath().forEach(latLng => bounds.extend(latLng));

        for (const marker of markersSemArea) {
          if (marker.idAreaAtendimento) {
            continue;
          }
          const latLng = this.criarLatLng(marker.latitude, marker.longitude);
          if (bounds.contains(latLng) && google.maps.geometry &&
            google.maps.geometry.poly.containsLocation(latLng, poligono)) {
            marker.idAreaAtendimento = area.id;
            marker.nomeAreaAtendimento = area.nome;
          }
        }
      }
    }
  }

  private generateMapAgrupamentoAreaAtendimento() {
    this.atribuirAreaAtendimentoMarkersPendentes();
    const markers = this.markers.filter(m => m.idAreaAtendimento && this.polygonsAreasAtendimento.some(p => p.id === m.idAreaAtendimento && p.visivel));

    return markers.reduce((map, marker) => {
      map[marker.idAreaAtendimento] = map[marker.idAreaAtendimento] || [];
      const agrupamento = { marker, pedidos: marker.pedidos };
      map[marker.idAreaAtendimento].push(agrupamento);
      return map;
    }, {});
  }

  private markerPossuiPedidoComTransportadora(): (value: MarkerAGM, index: number, array: MarkerAGM[]) => boolean {
    return m => {
      const pedidos = this.obterPedidosDoMarker(m);
      return pedidos && pedidos.filter(p => p.idTransportadora).length > 0;
    };
  }

  private obterMarkerAgrupadoTransportadora({cliente}: MarkerAGM): any {
    return ({marker}) =>
      marker.cliente.id === cliente.id
      && marker.cliente.idEndEntrega === cliente.idEndEntrega;
  }

  removerEfeitosMarkersAndMapaByOverlay(overlay: any, mapa: MapaRoteirizacaoComponent) {
    this.removerMap(overlay);
    this.removerAnimacaoMarkers();
    mapa.mostrarDrawingTools();
  }

  criarEntregaPontoPassagemListaEntregas(lat: any, long: any, idCliente, distancia) {
    return {
      idCliente,
      idEnderecoEntrega: '0',
      nome: 'Ponto Passagem',
      fantasia: '',
      cor: '',
      localizacao: {
        latitude: lat,
        longitude: long,
      },
      pedidos: [],
      razaoSocial: '',
      zonaRisco: false,
      isPontoPassagem: true,
      distancia
    };
  }

  criarEntregasPontoPassagem(lat: any, long: any, idCliente, sequencia: number, distancia?: number): EntregaSequenciaModel {
    return {
      chaveDeComparacao: '',
      endereco: {idCliente, idEnderecoEntrega: '', endereco: '', bairro: '', numero: ''},
      fantasia: '',
      idCliente,
      idEndEntrega: '',
      identificacaoPersonalizada: false,
      janelaEntrega: false,
      listaPedidos: [],
      localizacao: {latitude: lat, longitude: long},
      nome: 'Ponto Passagem',
      pedidos: '',
      possuiObservacao: false,
      razaoSocial: '',
      sequencia: (sequencia + 1),
      zonaRisco: false,
      isPontoPassagem: true,
      distancia
    };
  }

  criarClienteEntregaPontoPassagem(lat: any, long: any, idCliente: any): ClienteEntregaModel {
    return {
      id: idCliente,
      nome: 'Ponto Passagem',
      idEnderecoEntrega: '',
      identificacaoPersonalizada: false,
      janelaEntregaHabilitada: false,
      isPrimeiraEntrega: false,
      isUltimaEntrega: false,
      listaPedidos: [],
      latitude: lat,
      longitude: long,
      zonaRisco: false,
      isPontoPassagem: true,
    };
  }

  criarClienteEntregaPontoParada(lat: any, long: any, idCliente: any, original?): ClienteEntregaModel {
    return {
      id: idCliente,
      nome: 'Ponto Parada',
      idEnderecoEntrega: '',
      identificacaoPersonalizada: false,
      janelaEntregaHabilitada: false,
      isPrimeiraEntrega: false,
      isUltimaEntrega: false,
      listaPedidos: [],
      latitude: lat,
      longitude: long,
      zonaRisco: false,
      isPontoParada: true,
      original
    };
  }

  criarEntregasPontoParada(
    lat: any,
    long: any,
    idCliente,
    sequencia: number,
    distancia?: number,
    descricao?: string,
    original?: any,
    tipo?: 'CD' | 'Transportadora' | 'Ponto de Parada' | 'End. Cliente',
    observacao?: string,
    tempoMedio?: string | number,
    ultimaParada?: boolean
  ): EntregaSequenciaModel {
    return {
      chaveDeComparacao: '',
      endereco: {
        idCliente,
        idEnderecoEntrega: '0',
        cidade: this.valirdarObjetoCidade(original),
        endereco: original.logradouro,
        bairro: original.bairro,
        numero: original.numero,
        cep: original.cep,
      },
      fantasia: original.descricao,
      idCliente,
      idEndEntrega: '0',
      identificacaoPersonalizada: false,
      janelaEntrega: false,
      listaPedidos: [],
      localizacao: {latitude: lat, longitude: long},
      nome: descricao,
      pedidos: '',
      possuiObservacao: false,
      razaoSocial: original.descricao || original.nome,
      sequencia: (sequencia + 1),
      zonaRisco: false,
      isPontoParada: true,
      distancia,
      original,
      tipo,
      observacao,
      tempoMedio,
      ultimaParada
    };
  }

  valirdarObjetoCidade(original) {
    if (original.municipio) {
      return original.municipio;
    } else if (typeof original.cidade === 'object') {
      return original.cidade.nome;
    } else {
      return original.cidade;
    }
  }


  montarDadosTitulosMarkersClientes(markers, preCargaDTO = null, isPreCarga = true): Promise<any> {
    return new Promise<any>((resolve) => {
      const pracasDosMarkers: { sequencia: number; idPraca: string; }[] = [];

      const montarInfoPedidos = (marker) => {
        let infoPedidos = '';
        marker.pedidos.forEach(p => {
          infoPedidos += '\nPedido: ' + (p.numeroPedido || p.id) + '.' + (p.numeroNota ? (` NF: ${p.numeroNota}.`) : '') + (p.data ? (` Data: ${exibirDataNoFuso(p.data)}.`)  : '')
            + ' Peso: ' + this.capacidadeFormaterPipe.transform((p.pesoTotal || p.peso), 'Kg') + '.'
            + ' Volume: ' + this.capacidadeFormaterPipe.transform((p.volumeTotal || p.volume), 'm³') + '. Valor: ' +
            this.currencyPipe.transform((p.valorTotal || p.valor), 'BRL') + '.'
            + (p.idRca != null && p.nomeRca != null ? ' Rca: ' + p.idRca + ' - ' + p.nomeRca + '.' : '')
            + ` ${p.obsEntrega ? 'Obs. Entrega: ' + p.obsEntrega + '. ' : ''}`
            + `${p.obsEntrega1 ? 'Obs. Entrega 1: ' + p.obsEntrega1 + '. ' : ''}`
            + `${p.obsEntrega2 ? 'Obs. Entrega 2: ' + p.obsEntrega2 + '. ' : ''}`
            + `${p.obsEntrega3 ? 'Obs. Entrega 3: ' + p.obsEntrega3 + '. ' : ''}`;
        });
        return infoPedidos;
      };

      const montarDadosRota = (marker) => {
        let dadosRota = '';

        try {
          if (preCargaDTO && preCargaDTO.solucao && preCargaDTO.solucao.vehicleRoutes && isPreCarga) {
            const activitiesDriving = preCargaDTO.solucao.vehicleRoutes[0].routes[0].activities.filter((p) => p.activity === 'DRIVING');
            const idEndEntrega = marker.cliente.idEndEntrega ? marker.cliente.idEndEntrega : '0';
            const arrivalSite = marker.cliente.id + '_' + idEndEntrega;
            const drivingUltimoPin = activitiesDriving.find((p) => p.arrivalSite === arrivalSite);
            const drivingProximoPin = activitiesDriving.find((p) => p.departureSite === arrivalSite);

            if (drivingUltimoPin || drivingProximoPin) {
              const pontoAnterior = drivingUltimoPin.departureSite.split('_');
              const proximoPonto = drivingProximoPin.arrivalSite.split('_');

              dadosRota = '\nSequência Prevista: ' + (activitiesDriving.indexOf(drivingUltimoPin) + 1) + '.'
                + '\nDistância ' + (pontoAnterior[0] !== 'CD' ? getPrefixPonto(pontoAnterior) : 'CD ' +
                  preCargaDTO.centroDistribuicao.nome) + ' Anterior : ' + (drivingUltimoPin.distance / 1000) + ' Km.'
                + '\nDistância Próximo ' + (proximoPonto[0] !== 'CD' ? getPrefixPonto(proximoPonto) : 'CD ' +
                  preCargaDTO.centroDistribuicao.nome) + ' : ' + (drivingProximoPin.distance / 1000) + ' Km.\n';
            }
          } else {
            const index = preCargaDTO.entregas.findIndex(entrega => entrega.idCliente === marker.cliente.id &&
              entrega.idEndEntrega === marker.cliente.idEndEntrega);
            dadosRota = '\nSequência Prevista: ' + (preCargaDTO.entregas[index].sequencia) + '.'
              + '\nDistância ' + (preCargaDTO.entregas[index].sequencia === 1 ? preCargaDTO.centroDistribuicao.nome :
                (preCargaDTO.entregas[index - 1].idCliente))
              + ' Anterior : ' + (preCargaDTO.entregas[index].distancia / 1000) + ' Km.'
              + '\nDistância Próximo ' + (preCargaDTO.entregas[index].sequencia === preCargaDTO.entregas.length ?
                preCargaDTO.centroDistribuicao.nome + ': ' + (preCargaDTO.entregas[index].distancia / 1000) + ' Km.\n'
                : (preCargaDTO.entregas[index + 1].idCliente) + ': ' + (preCargaDTO.entregas[index].distancia / 1000) + ' Km.\n');
          }
          return dadosRota;
        } catch (err) {
          console.error('Erro ao montar dados titulo marker: ', err);
          console.log(preCargaDTO);
          return '';
        }
      };

      const montarMarkerTitulo = (marker, praca, infoPedidos, dadosRota) =>  {
        return 'Cliente: ' + marker.cliente.id + ' - ' + marker.cliente.razaoSocial + '\n'
          + 'Fantasia: ' + marker.cliente.fantasia + '\n'
          + 'Praça: ' + (praca ? praca.id + ' - ' + praca.descricao : 'não possui') + '\n'
          + 'Rota: ' + (marker.cliente.idRota ? marker.cliente.idRota + ' - ' + marker.cliente.descricaoRota : '') + '\n'
          + 'Obs. Rota: ' + (marker.cliente.obsRota ? marker.cliente.obsRota : '') + '\n'
          + 'Cidade: ' + marker.cliente.cidade + '\n'
          + 'Endereço: ' + marker.cliente.endereco + '\n'
          + 'Número: ' + marker.cliente.numero + '\n'
          + 'CEP: ' + marker.cliente.cep + '\n'
          + 'Valor da entrega: R$ ' + marker.valor
          + infoPedidos + '\n\n'
          + 'Pedidos: ' + ((marker.pedidos && marker.pedidos.length) ? marker.pedidos.length : '0')
          + dadosRota;
      };

      markers.forEach((marker, index) =>  {
        if (marker.idPraca && !isNaN(Number(marker.idPraca))) {
          pracasDosMarkers.push({ sequencia: index, idPraca: marker.idPraca });
        } else {
          const dadosRota = montarDadosRota(marker);
          const infoPedidos = montarInfoPedidos(marker);
          marker.title = montarMarkerTitulo(marker, null, infoPedidos, dadosRota);
        }
      });

      if (pracasDosMarkers.length > 0) {
        this.pracaService.consultarListaDePracas(pracasDosMarkers).subscribe((pracas) => {
          pracas.forEach((praca) => {
            const index = praca.sequencia;
            const marker = markers[index];
            const dadosRota = montarDadosRota(marker);
            const infoPedidos = montarInfoPedidos(marker);
            marker.title = montarMarkerTitulo(marker, praca, infoPedidos, dadosRota);
          });
          resolve(markers);
        });
      } else {
        resolve(markers);
      }
    });
  }


  async getParametroVisualizarSomenteObsEntrega() {
    return await this.paramEspecificoLocalStorageService.getParametroEspecificoLocalStorage('VISUALIZAR_SOMENTE_OBSENTREGA');
  }

  setPoligonosAreasAtendimento(poligonos: PolignoModel[]) {
   this.polygonsAreasAtendimento = poligonos;

   this.polygonAreasAtendimentoChangedEventEmitter.emit(this.polygonsAreasAtendimento);
  }

  getPoligonosAreasAtendimento() {
  return this.polygonsAreasAtendimento;
  }


  consultarMarkersPorEntregas(entregas: EntregaPedidoConfig[]) {
    const idsEntregas = new Set(entregas.map((entrega) => entrega.id));
    return this.markers.filter((marker) => idsEntregas.has(marker.cliente.id));
  }

  getMarkersFiltradosValue() {
    return this.markersFiltrados.getValue();
  }

  contemMarkersFiltrados() {
    return this.markersFiltrados.getValue().length > 0;
  }

  getMarkersFiltrados() {
    return this.markersFiltrados.asObservable();
  }

  setMarkersFiltrados(markers: MarkerAGM[]) {
    this.markersFiltrados.next(markers);
  }

  setOrigemDetalhesEntrega(value: boolean) {
    this.origemDetalhesEntrega = value;
  }

  getOrigemDetalhesEntrega() {
    return this.origemDetalhesEntrega;
  }

  getMarkersNasAreasDeAtendimentoSelecionadas() {
    return this.markersNasAreasDeAtendimentoSelecionadas.asObservable();
  }

  getMarkersNasAreasDeAtendimentoSelecionadasValue() {
    return this.markersNasAreasDeAtendimentoSelecionadas.getValue();
  }

  setMarkersNasAreasDeAtendimentoSelecionadas(markers: MarkerAGM[]) {
    const selecionaveis = this.filtrarMarkersSelecionaveis(markers);
    if (!isEqual(selecionaveis, this.markersNasAreasDeAtendimentoSelecionadas.getValue())) {
      this.markersNasAreasDeAtendimentoSelecionadas.next(selecionaveis);
    }
  }

  obterMarkersByOverlayOuFiltrados(overlay) {
    if (this.contemMarkersFiltrados()) {
      return this.filtrarMarkersSelecionaveis(this.getMarkersFiltradosValue());
    }

    if(this.existeOverlayValido(overlay)) {
      return this.obterListaMarksAgmDentroOverlay(overlay);
    }

    return this.filtrarMarkersSelecionaveis(this.getMarkersNasAreasDeAtendimentoSelecionadasValue());
  }

  private filtrarMarkersSelecionaveis(markers: MarkerAGM[]): MarkerAGM[] {
    if (this.quantidadeSelecaoBloqueada === 0 && !this.possuiFiltroFornecedores()) {
      return markers;
    }
    return markers.filter((marker) => !marker.selecaoBloqueada && !marker.ocultoPorFiltroFornecedor);
  }

  private podeSelecionarMarker(marker: MarkerAGM): boolean {
    return marker.isVisivel && !marker.selecaoBloqueada && !marker.ocultoPorFiltroFornecedor;
  }

  possuiFiltroFornecedores(): boolean {
    return this.fornecedoresFiltrados.getValue().length > 0;
  }

  async aplicarFiltroFornecedores(codigosFornecedores: string[], numerosPedidosDosFornecedores: Set<number>): Promise<MarkerAGM[]> {
    const markersEmPreCargaRestaurados = await this.restaurarPedidosOcultosPorFiltroFornecedor();

    for (const marker of this.markers) {
      if (marker.idPreCarga || marker.isPontoPassagem || marker.isPontoParada) {
        continue;
      }

      const pedidosOcultos = marker.pedidos.filter(pedido => !numerosPedidosDosFornecedores.has(pedido.numeroPedido));
      if (!pedidosOcultos.length) {
        continue;
      }

      this.pedidosOcultosPorFiltroFornecedor.set(marker, pedidosOcultos);
      marker.pedidos = marker.pedidos.filter(pedido => !pedidosOcultos.includes(pedido));
      marker.ocultoPorFiltroFornecedor = !marker.pedidos.length;
      if (!marker.ocultoPorFiltroFornecedor) {
        await this.redefinirMarkerAGM(marker, marker.cor, false, marker.idPreCarga);
      }
    }

    this.fornecedoresFiltrados.next(codigosFornecedores);
    this.atualizaMarkers();

    return markersEmPreCargaRestaurados;
  }

  async removerFiltroFornecedores(): Promise<MarkerAGM[]> {
    const markersEmPreCargaRestaurados = await this.restaurarPedidosOcultosPorFiltroFornecedor();
    this.fornecedoresFiltrados.next([]);
    this.atualizaMarkers();

    return markersEmPreCargaRestaurados;
  }

  private async restaurarPedidosOcultosPorFiltroFornecedor(): Promise<MarkerAGM[]> {
    const markersEmPreCarga: MarkerAGM[] = [];

    for (const [marker, pedidosOcultos] of Array.from(this.pedidosOcultosPorFiltroFornecedor.entries())) {
      marker.ocultoPorFiltroFornecedor = false;

      if (!this.markers.includes(marker)) {
        await this.restaurarPedidosOcultosDeMarkerForaDoMapa(marker, pedidosOcultos, markersEmPreCarga);
        continue;
      }

      marker.pedidos = [...marker.pedidos, ...pedidosOcultos];

      if (marker.idPreCarga) {
        markersEmPreCarga.push(marker);
      } else {
        await this.redefinirMarkerAGM(marker, marker.cor, false, marker.idPreCarga);
      }
    }

    this.pedidosOcultosPorFiltroFornecedor.clear();

    return markersEmPreCarga;
  }

  private async restaurarPedidosOcultosDeMarkerForaDoMapa(marker: MarkerAGM, pedidosOcultos: PedidosPreCargaModel[],
                                                          markersEmPreCarga: MarkerAGM[]) {
    const markerExistente: MarkerAGM = this.existeMarkerParaClienteEnderecoEntrega(marker);

    if (markerExistente) {
      const pedidosNaoExistentes = pedidosOcultos.filter(pedido =>
        !markerExistente.pedidos.some(p => p.numeroPedido === pedido.numeroPedido));
      markerExistente.pedidos = [...markerExistente.pedidos, ...pedidosNaoExistentes];

      if (markerExistente.idPreCarga) {
        markersEmPreCarga.push(markerExistente);
      } else {
        await this.redefinirMarkerAGM(markerExistente, markerExistente.cor, false, null);
      }
      return;
    }

    marker.pedidos = [...pedidosOcultos];
    this.markers.push(marker);
    await this.redefinirMarkerAGMEstadoInicial(marker, true);
  }

  existeOverlayValido(overlay) {
    return overlay && overlay.map && (this.isOverlayIsRectangle(overlay) || this.isOverlayIsPolygon(overlay) || this.isOverlayIsCircle(overlay));
  }


  async obterListaMarksAgmDentroPoligonoAreaAtendimento(overlay: google.maps.Polygon, idArea,
                                                        nomeArea, chunkSize = 500): Promise<MarkerAGM[]> {
    if (!overlay) {
      return [];
    }

    const novaLista: MarkerAGM[] = [];

    const bounds = new google.maps.LatLngBounds();
    overlay.getPath().forEach((latLng) => bounds.extend(latLng));

    let i = 0;
    while (i < this.markers.length) {
      const slice = this.markers.slice(i, i + chunkSize);

      for (const marker of slice) {
        const latLng = this.criarLatLng(marker.latitude, marker.longitude);

        if (bounds.contains(latLng) && google.maps.geometry &&
          google.maps.geometry.poly.containsLocation(latLng, overlay)) {

          marker.idAreaAtendimento = idArea;
          marker.nomeAreaAtendimento = nomeArea;
          novaLista.push(marker);
        }
      }

      i += chunkSize;

      await new Promise(r => setTimeout(r, 0));
    }

    return novaLista;
  }


  async obterMarkersPorAreaDeAtendimento(area) {

    const result = [];

    for (const path of area.paths) {

    const paths = path.map(p => new google.maps.LatLng(p.lat, p.lng));

    const poligono = new google.maps.Polygon({ paths });

    result.push(... await this.obterListaMarksAgmDentroPoligonoAreaAtendimento(poligono, area.id, area.nome, 500));
    }

    return result;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  setMarkersComMesmaLocalizacao(markers: MarkerAGM[]) {
    this.markersComMesmaLocalizacao = markers;
  }

  getMarkersComMesmaLocalizacao() {
    return this.markersComMesmaLocalizacao;
  }

  salvarCopiaMarkersAntesDaTransferencia() {
    this.copiaMarkersAntesDaTransferencia = cloneDeep(this.markers);
  }

  getCopiaMarkersAntesDaTransferencia() {
    return this.copiaMarkersAntesDaTransferencia;
  }

  atualizarListaMarkers(listaMarkers: MarkerAGM[]) {
    this.markers = cloneDeep(listaMarkers);
    this.atualizaMarkers();
  }

  public removerTrajetoRotaTodasPreCargas() {
    this.preCargaRotas.next([]);
  }

  public atualizarRotasPreCargasByIdPrecarga(idPreCarga: string, visualizarRotaModel: PreCargaRotaModel, deletarSeExistir: boolean) {
    const itemFoundIndex = this.preCargaRotas.getValue().findIndex(p => p.idPreCarga === idPreCarga);

    if (itemFoundIndex > -1) {
      if (deletarSeExistir) {
        const rotas = [...this.preCargaRotas.getValue()];
        rotas.splice(itemFoundIndex, 1);
        this.preCargaRotas.next(rotas);
      } else {
        const rotas = [...this.preCargaRotas.getValue()];
        rotas.splice(itemFoundIndex, 1, visualizarRotaModel);
        this.preCargaRotas.next(rotas);
      }
      return;
    }

    this.preCargaRotas.next([...this.preCargaRotas.getValue(), visualizarRotaModel]);
  }

  public existeRotaSalva(idPreCarga: string) {
    return this.preCargaRotas.getValue().some(p => p.idPreCarga === idPreCarga);
  }

  public getRotasPreCargasObservable() {
    return this.preCargaRotas.asObservable();
  }

  public verRotaDaEntregaNoMapa(preCargaModel: PreCargaModel, deletarSeExistir?: boolean) {
    const coordenadas = this.getPolylineRoutes(preCargaModel.preCargaDTO.solucao.vehicleRoutes[0].routes[0]);

    const obj: PreCargaRotaModel = {
      idPreCarga: preCargaModel.id,
      cor: preCargaModel.cor,
      coordenadas: filtrarCoordenadas(coordenadas, 'baixo')
    };

    this.atualizarRotasPreCargasByIdPrecarga(preCargaModel.id, obj, deletarSeExistir);
  }

  public atualizarCorDaRota(idPreCarga: string, cor: string) {
    const itemFoundIndex = this.preCargaRotas.getValue().findIndex(p => p.idPreCarga === idPreCarga);

    if (itemFoundIndex === -1) { return; }

    this.preCargaRotas.getValue()[itemFoundIndex].cor = cor;
  }

  private getPolylineRoutes(route: RouteModel) {
    const filteredRoutes: any = route.activities
      .filter(activity => activity.activity === 'DRIVING')
      .filter(activity => typeof activity.polylineRoute !== 'undefined' && activity.polylineRoute);

    return filteredRoutes.flatMap(activity => activity.polylineRoute.coordinates);
  }

  removerRotaPreCarga(idPreCarga: string) {
    const itemFoundIndex = this.preCargaRotas.getValue().findIndex(p => p.idPreCarga === idPreCarga);

    if (itemFoundIndex === -1) {
      return;
    }

    const rotas = [...this.preCargaRotas.getValue()];
    rotas.splice(itemFoundIndex, 1);
    this.preCargaRotas.next(rotas);

  }

  verificarPossuiPedidoAvulso(pedidos): boolean {
    return !isNullOrUndefined(pedidos) && (typeof pedidos !== 'string')
      && pedidos.some(ped =>  ped.tipo === 'CA' || ped.tipo === 'EA');
  }

  alterarVisibilidadeMarker(marker: MarkerAGM, visivel: boolean) {
    marker.isVisivel = visivel;
  }

  private async obterParametroExibirCepPin() {
    let paramExibirCabecaCepPin;
    await this.paramEspecificoLocalStorageService.getParametroEspecificoLocalStorage('EXIBIR_CABECA_CEP_PIN').then((param) => {
        paramExibirCabecaCepPin = param;
      });

    return paramExibirCabecaCepPin === 'S';
  }

  private async obterParametroValidarAtrasoEntrega() {
    return await this.paramEspecificoLocalStorageService.getParametroEspecificoLocalStorage('VALIDAR_ATRASO_ENTREGA').then(
      (param) => param === 'S'
    ).catch(() => false);
  }

  atualizarPrimeiraEntrega(marker: MarkerAGM, item: PreCargaModel | RomaneioRoteirizacaoModel) {
    const idEnderecoEntreaMarer = marker.cliente.idEndEntrega != null ? marker.cliente.idEndEntrega : '0';
    const idEnderecoPrecarga = item.primeiraEntrega != null && item.primeiraEntrega.idEnderecoEntrega != null ? item.primeiraEntrega.idEnderecoEntrega : '0';

    if (item.primeiraEntrega != null && marker.cliente.id === item.primeiraEntrega.idCliente && idEnderecoEntreaMarer === idEnderecoPrecarga) {
      throw new Error('A primeira entrega já está atualizada');
    }

    let entregas: (ClienteEntregaModel | EntregaPreCargaModel)[] = [];

    if ('listaEntregas' in item) {
      entregas = item.listaEntregas || [];
    } else if ('entregas' in item) {
      entregas = item.entregas || [];
    }

    item.primeiraEntrega = entregas.find(en => {
      const idEndEntrega = en.idEnderecoEntrega != null ? en.idEnderecoEntrega : '0';
      return en.idCliente === marker.cliente.id && idEndEntrega === idEnderecoEntreaMarer;
    })
  }
}

